import { Component } from '@angular/core';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component";
import { RouterLink } from "@angular/router";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { License } from '../../../../models/License';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { VirtualClassroom } from '../../../../models/VirtualClassroom';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-virtual-classroom-configuration',
  standalone: true,
  imports: [
    RouterLink,
    GenericCrudComponent
  ],
  templateUrl: './virtual-classroom-configuration.component.html',
  styleUrl: './virtual-classroom-configuration.component.css'
})
export class VirtualClassroomConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Descripción', active: true, type: 'text', key: 'description', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  unitFormFields: GenericFormField[] = [
    { name: 'id', type: 'hidden', label: 'ID', validations: '', colspan: 1 },
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'external_test_url', type: 'text', label: 'Enlace a test externo (URL)', validations: '', colspan: 2 },
    { name: 'images', type: 'image', label: 'Imagenes', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
    { name: 'videos', type: 'video', label: 'Videos', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
    { name: 'documents', type: 'document', label: 'Documentos', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
  ];

  unitsForm: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.unitFormFields,
    name: 'unit',
    createButtonTitle: 'Nueva Unidad',
    cols: 2,
    createApiSlug: '/config/virtual-classroom/listAll',
    originalUpdateApiSlug: '/config/virtual-classroom/update/{{id}}',
    formTitle: 'Crear Unidad',
    formButtonTitle: 'Crear Unidad',
    updateFormTitle: 'Editar Unidad',
    updateFormButtonTitle: 'Editar Unidad',
    width: '4xl',
  }

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'units', type: 'repeater', label: 'Unidades', colspan: 2, singleSelection: false, genericForm: this.unitsForm },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'units', type: 'repeater', label: 'Unidades', colspan: 2, singleSelection: false, genericForm: this.unitsForm },
  ];


  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'aula virtual',
    createButtonTitle: 'Nueva aula virtual',
    cols: 2,
    createApiSlug: '/config/virtual-classroom/store',
    formTitle: 'Crear aula virtual',
    formButtonTitle: 'Crear aula virtual',
    width: '4xl',
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      // actionSlug: '/config/office/update/{{id}}',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'virtual-classrooms',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/config/virtual-classroom/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        originalUploadFilesUrl: '/config/virtual-classroom/update-files/{{id}}',
        width: '4xl',
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar el aula virtual?',
      deleteRowOnResponse: true,
      actionSlug: '/config/virtual-classroom/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<VirtualClassroom>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/virtual-classroom/index',
    paginate: true,
    name: 'aulas virtuales',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|description', operator: 'like', placeholder: 'Nombre o descripción' },
    //{type: 'date-between', key: 'created_at', operator: 'between', parsed: "date-arr", placeholder: 'Fecha de creación'},
  ];

  genericCRUD: GenericCRUD<Paginator<VirtualClassroom>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: true
  }
}
